import { render, staticRenderFns } from "./CreateAccessPage.vue?vue&type=template&id=3833e8f9&scoped=true&"
import script from "./CreateAccessPage.vue?vue&type=script&lang=js&"
export * from "./CreateAccessPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccessPage.vue?vue&type=style&index=0&id=3833e8f9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833e8f9",
  null
  
)

export default component.exports